// Rollen-Labels + Badge-Klassen — eine Quelle (ersetzt die duplizierten Maps in
// Mitarbeiter.vue / mitarbeiter/ShowView.vue). Werte = User#role-Enum (Backend).
export const ROLE_OPTIONS = [
  { value: 'a_admin',    label: 'A-Admin (Inhaber)' },
  { value: 'b_admin',    label: 'B-Admin' },
  { value: 'kalkulator', label: 'Kalkulator' },
  { value: 'bearbeiter', label: 'Bearbeiter' }
]

const LABELS = Object.fromEntries(ROLE_OPTIONS.map(o => [o.value, o.label]))

const BADGES = {
  a_admin:    'bg-danger',
  b_admin:    'bg-warning text-dark',
  kalkulator: 'bg-primary',
  bearbeiter: 'bg-info text-dark'
}

export function roleLabel(role) {
  return LABELS[role] || role || '-'
}

export function roleBadgeClass(role) {
  return BADGES[role] || 'bg-secondary'
}
